import React from "react";

import PageHero from "components/site/PageHero";
import RevealBlock from "components/site/RevealBlock";
import { Col, Container, Row } from "components/site/SitePrimitives";
import SiteShell from "components/site/SiteShell";
import {
  buildStructuredData,
  currentWorkPage,
} from "content/siteContent";
import usePageMeta from "hooks/usePageMeta";

function CurrentWork() {
  usePageMeta({
    ...currentWorkPage.meta,
    structuredData: buildStructuredData({
      pageName: "Current Work",
      description: currentWorkPage.meta.description,
      path: currentWorkPage.meta.path,
    }),
  });

  return (
    <SiteShell pageClassName="ignitum-site-page ignitum-current-work-page">
      <PageHero
        aside={
          <RevealBlock variant="card">
            <p className="site-panel-label">Signal level</p>
            <ul className="site-signal-list">
              {currentWorkPage.hero.signals.map((signal) => (
                <li key={signal}>{signal}</li>
              ))}
            </ul>
          </RevealBlock>
        }
        compact
        description={currentWorkPage.hero.description}
        eyebrow={currentWorkPage.hero.eyebrow}
        title={currentWorkPage.hero.title}
      />

      <section className="site-section">
        <Container>
          <Row className="site-card-grid">
            {currentWorkPage.items.map((item, index) => (
              <Col key={item.title} md="4">
                <RevealBlock delay={index * 70} variant="card">
                  <div className="site-card site-split-card">
                    <p className="site-card-label">{item.label}</p>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </RevealBlock>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="site-section site-section-muted">
        <Container>
          <RevealBlock className="site-section-intro" variant="lift">
            <p className="site-eyebrow">Discussion boundaries</p>
            <h2>{currentWorkPage.discussion.title}</h2>
          </RevealBlock>
          <Row className="site-card-grid">
            {currentWorkPage.discussion.rows.map((row, index) => (
              <Col key={row.label} md="6">
                <RevealBlock
                  delay={index * 80}
                  variant={index === 0 ? "slide-left" : "slide-right"}
                >
                  <div className="site-card">
                    <h3>{row.label}</h3>
                    <p>{row.text}</p>
                  </div>
                </RevealBlock>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </SiteShell>
  );
}

export default CurrentWork;
